import { render, staticRenderFns } from "./to-return.vue?vue&type=template&id=5160919c&scoped=true"
import script from "./to-return.vue?vue&type=script&lang=js"
export * from "./to-return.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5160919c",
  null
  
)

export default component.exports